import React from 'react';
import { Download } from 'lucide-react';
import { DeactivationLog } from '@/services/InstructorService/InstructorUsersService';
import './DeactivationLogTab.css';

interface DeactivationLogTabProps {
  deactivationLogs: DeactivationLog[];
}

const DeactivationLogTab: React.FC<DeactivationLogTabProps> = ({ deactivationLogs }) => {
  return (
    <div className="trainer-user-deactivation">
      <div className="trainer-user-deactivation-header">
        <div className="trainer-user-deactivation-info">
          <h2>Deactivation Log</h2>
          <p>Audit trail of deactivated user accounts</p>
        </div>
        <button className="trainer-user-deactivation-export-btn">
          <Download size={18} />
          Export Log
        </button>
      </div>

      <div className="trainer-user-deactivation-table-container">
        <table className="trainer-user-deactivation-table">
          <thead>
            <tr>
              <th>USER</th>
              <th>DEPARTMENT</th>
              <th>DEACTIVATED BY</th>
              <th>DEACTIVATION DATE</th>
              <th>REASON</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {deactivationLogs.map((log) => (
              <tr key={log.id}>
                <td>
                  <div className="trainer-user-deactivation-user-cell">
                    <div className="trainer-user-deactivation-avatar">
                      {log.userName.split(' ').map(n => n[0]).join('').toUpperCase()}
                    </div>
                    <div>
                      <div className="trainer-user-deactivation-name">{log.userName}</div>
                    </div>
                  </div>
                </td>
                <td>{log.department}</td>
                <td>{log.deactivatedBy}</td>
                <td>{log.deactivatedDate}</td>
                <td>{log.reason}</td>
                <td>
                  <button className="trainer-user-deactivation-reactivate-btn">Reactivate</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DeactivationLogTab;
